import React from "react";
//#region types
import { DividendSuggestionsFieldProps } from "models/propTypes/annualAccountPropTypes";
import { CurrencyCode } from "models/enums/currency";
//#endregion
//#region components
import { Suggestions } from "components/common/wintForms";
//#endregion
import { CurrencyHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import useDividendProposal from "../../annualReportToApprove/useDividendProposal";

const DividendSuggestionsField: React.FC<DividendSuggestionsFieldProps> = ({
  dividendProposal,
  maxAllowedDividend,
  setValue,
}) => {
  const maxAllowedDividendRounded =
    maxAllowedDividend !== undefined ? CurrencyHelper.toRoundedDownNearestThousand(maxAllowedDividend) : undefined;
  const { hasDividendProposal, dividendProposalRounded } = useDividendProposal(dividendProposal, maxAllowedDividend);

  const suggestions = [
    {
      id: "zeroDividend",
      value: LocalizationHelperInstance.getFormattedCurrency(0, CurrencyCode.SEK, 0, 0),
      data: 0,
    },
  ]
    .concat(
      hasDividendProposal && dividendProposalRounded !== maxAllowedDividendRounded
        ? [
            {
              id: "dividendProposal",
              value: LocalizationHelperInstance.getFormattedCurrency(dividendProposalRounded!, CurrencyCode.SEK, 0, 0),
              data: dividendProposalRounded!,
            },
          ]
        : []
    )
    .concat(
      maxAllowedDividendRounded !== undefined && maxAllowedDividendRounded !== 0
        ? [
            {
              id: "maxDividend",
              value: LocalizationHelperInstance.getFormattedCurrency(maxAllowedDividendRounded, CurrencyCode.SEK, 0, 0),
              data: Math.floor(maxAllowedDividendRounded),
            },
          ]
        : []
    );

  return (
    <Suggestions
      suggestions={suggestions}
      setValue={setValue}
      className={clsx(cssExports.compact, cssExports.suggestionsTopSpacing)}
    />
  );
};

export default DividendSuggestionsField;
